<template >
<div class="container-fluid" v-if="lesson">
   
   <div class="row">
     <div class="col-md-8 col-sm-12">

    
      <div class="card mb-4" >
        <div class="card-header py-3">
          <div class="row">
            <div class="col col-expand">
              <h3 class="m-0 font-weight-bold text-primary" >{{lesson.name}}</h3>
            </div>

          </div>
        </div>
        <div class="card-body" v-if="student">
          <p>Нэр: {{student.name}}</p>
          <p>Регистр: {{student.register}}</p>
          <div v-if="topics && topics.length>0">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Явц</th>
                  <th>Дүн</th>
                </tr>
              </thead>

              <tbody >
                <tr v-for="(topic, sindex) in topics">
                  <td>{{topic.name}}</td>
                  <td >
                    <div v-if="topic.data" class="text-primary text-center">{{topic.data.earnedScore}}</div>
                    <span v-if="topic && topic.data && topic.data" class="text-white">
                      
                      <div class="row">
                        <div class="col" v-if="topic.data.procent">
                          <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+topic.data.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{topic.data.procent}} %</div>
                          </div>
                        </div>
                        <div class="col" v-else>
                          <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span v-else>-</span>                  
                  </td>
          
                </tr>
              </tbody>
   
            </table>
          </div>
          <div v-else class="alert alert-warning text-center mb-4"><h4>Одоогоор мэдээлэл байхгүй байна.</h4></div>
        </div>
      </div>



      
      <hr class="mb-5"/>
      
   

     </div>
     <div class="col-md-4 col-sm-12">
       <lesson-info :lesson="lesson" :schoolId="schoolId" :edit="false" :showDetail="false"></lesson-info>
     </div>
   </div>

   
</div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment,{ max } from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../school/shared/LessonInfo';
export default {
    name: "StudentScores",

    data() {
        return {
            lesson: null,
            topic:null,
            content:null,
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
                        
            display:0,
            tagText:null,
            dayStr:null,
            selectedCell:null,
            selectedTopicIndex:null,
            selectedGroupIndex:null,
            schools:[],
            teachers:[],
            school:null,
            teacher:null,
            groups:[],
            student:null

            
        };
    },
    methods: {
        
      async _getQA(){


          var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).get();
          let lesson=doc.data();
          lesson.id=doc.id;
          this.lesson=lesson;
        
        await this.getStudents();
        await this.getTopics();  
      },
      async getStudents(){
        if(this.lesson && this.userProfile && this.userProfile.customer){

          var doc=await this.userProfile.customer.get();
          if(doc.exists){
            let object=doc.data();
            object.id = doc.id;
            object.ref=doc.ref;
            this.student=object;
            
            // if(object){
            //   var y = {};
            //   y.data={earnedScore:null};
            //   fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection("details").doc(this.contentId).collection('sstudents').doc(object.id).onSnapshot(sdoc=>{
            //     if(sdoc.exists){
            //       y.data=sdoc.data();
                  
            //       object.score=Object.assign({}, y);
            //     }
            //   });
              
            // }
          }
          
        }
      },
      async getTopics(){
        if(this.lesson!=null && this.lesson!=undefined && this.student){
          var topicSnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).collection("scores").orderBy("createdAt","desc").get();
          if(topicSnapshot && !topicSnapshot.empty){
            this.topics=[];
            for(const doc of topicSnapshot.docs){
              let object=doc.data();
              object.id = doc.id;
              object.data=null;
              if(this.student){
                doc.ref.collection("sstudents").doc(this.student.id).onSnapshot(sdoc=>{
                  if(sdoc.exists){                 
                    object.data=sdoc.data();
                  }
                });
                  
                
              }

              this.topics.push(object);
            }
      
          }
          
        }
      },

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      LessonInfo
    },
    props: {
      schoolId:{
        required:true
      },
      lessonId: { 
          required: true,
      },

    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

